<template>
  <v-app>
    <div id="register">
      <div class="top-container">
        <img
          class="one-inventory-blue"
          src="@/assets/ez-cms-horizontal.png"
          alt
          style="height: 47px; width: auto"
          @click="redirectToLogin"
        />
      </div>
      <div class="content">
        <div class="text">
          <p>{{ $t("_REGISTER.WELCOME") }}</p>
          <p v-if="state != 4">{{ $t("_REGISTER.SOLOGAN") }}</p>
        </div>
        <div class="steps">
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 1" />
            <div v-if="state <= 1" class="circle" :class="{ active: state == 1 }"></div>
            <span :class="{ active: state == 1 }">
              {{
              $t("_REGISTER.PERSONAL_DETAIL")
              }}
            </span>
          </div>
          <hr />
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 2" />
            <div v-if="state <= 2" class="circle" :class="{ active: state == 2 }"></div>
            <span :class="{ active: state == 2 }">
              {{
              $t("_REGISTER.HOTEL_DETAIL")
              }}
            </span>
          </div>
          <hr />
          <div class="step">
            <font-awesome-icon icon="check" v-if="state > 3" />
            <div v-if="state <= 3" class="circle" :class="{ active: state == 3 }"></div>
            <span :class="{ active: state == 3 }">
              {{
              $t("_REGISTER.CREATE_ACCOUNT")
              }}
            </span>
          </div>
        </div>
        <!-- end steps -->

        <!-- personal details -->
        <v-form ref="form1" lazy-validation v-on:submit.prevent class="w-100">
        <div :class="( state == 1 ) ? 'personal-detail d-block' : 'personal-detail d-none'">
          <v-row>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.FULLNAME") }}*</label>
              <v-text-field
                :placeholder="$t('_REGISTER.YOUR_FULLNAME')"
                maxlength="50"
                v-model="data.fullName"
                :rules="[rules.required]"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-radio-group class="sex" row v-model="data.gender">
                <v-radio color="indigo darken-3" :label="$t('_REGISTER.MALE')" :value="1"></v-radio>
                <v-radio color="indigo darken-3" :label="$t('_REGISTER.FEMALE')" :value="0"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col sm="4">
              <label>{{ $t("_REGISTER.PERSONAL_PHONE") }}*</label>
              <v-text-field
                placeholder="(+84)"
                v-model="data.phone"
                :rules="[rules.required, rules.phone]"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.EMAIL") }}*</label>
              <v-text-field
                :placeholder="$t('_REGISTER.YOUR_EMAIL')"
                v-model="data.email"
                :rules="[rules.required, rules.email]"
                outlined
                dense
                autocomplete="false"
                :error-messages="errors.email"
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.POSITION") }}*</label>
              <v-text-field
                maxlength="50"
                :placeholder="$t('_REGISTER.YOUR_POSITION')"
                v-model="data.position"
                :rules="[rules.required]"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
        </v-form>
        <!-- end personal details -->

        <!-- hotel details -->
         <v-form ref="form2" lazy-validation v-on:submit.prevent class="w-100">
        <div :class=" (state == 2 ) ? 'hotel-detail d-block' : 'hotel-detail d-none'">
          <v-row>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.HOTEL_NAME") }} *</label>
              <v-text-field
                :placeholder="$t('_REGISTER.YOUR_COMPANY_NAME')"
                v-model="data.hotelName"
                :rules="[rules.required]"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.WEBSITE") }}</label>
              <v-text-field
                :placeholder="$t('_REGISTER.YOUR_WEBSITE_LINK')"
                v-model="data.hotelWebsite"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.HOTEL_PHONE") }} *</label>
              <v-text-field
                placeholder="(+84)"
                v-model="data.hotelPhone"
                :rules="[rules.required, rules.phone]"
                outlined
                dense
                type="phone"
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.HOTEL_EMAIL") }} *</label>
              <v-text-field
                :placeholder="$t('_REGISTER.ENTER_EMAIL')"
                v-model="data.hotelEmail"
                :rules="[rules.required, rules.email]"
                outlined
                dense
                :error-messages="errors.hotelEmail"
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.HOTEL_TYPE") }} *</label>
              <v-select
                item-text="text"
                item-value="value"
                :items="select.hotelTypes"
                v-model="data.hotelTypeId"
                :rules="[rules.required]"
                outlined
                dense
              >
              </v-select>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.STAR") }} *</label>
              <v-select
                item-text="text"
                item-value="value"
                :items="select.stars"
                v-model="data.hotelStar"
                outlined
                dense
              >
              </v-select>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.NUMBER_OF_ROOMS") }} *</label>
              <v-text-field
                :placeholder="$t('_REGISTER.ENTER_ROOM_QUANTITY')"
                maxlength="4"
                v-model="data.hotelNumberOfRooms"
                :rules="[rules.required, rules.maxroom]"
                outlined
                dense
                type="number"
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.TAX_CODE") }} *</label>
              <v-text-field
                :placeholder="$t('_REGISTER.ENTER_TAX_CODE')"
                v-model="data.hotelTaxCode"
                :rules="[rules.required]"
                outlined
                dense
                type="number"
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("UTC") }} *</label>
              <treeselect
                name="utc"
                instanceId="utc"
                :options="optionUTC"
                :default-expand-level="1"
                :placeholder="$t('UTC')"
                :disable-branch-nodes="true"
                v-model="data.timeZoneStr"/>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.COUNTRY") }} *</label>
               <treeselect  name="country" instanceId="country" :options="select.countries" :default-expand-level="1" :disable-branch-nodes="true" v-model="country" :clearable="false" />
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.CITY") }} *</label>
              <treeselect  name="cities" instanceId="cities" :options="select.cities" :default-expand-level="1" :disable-branch-nodes="true" v-model="city" :clearable="false" />
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.DISTRICT") }} *</label>
              <treeselect  name="districts" instanceId="districts" :options="select.districts" :default-expand-level="1" :disable-branch-nodes="true" v-model="data.hotelLocId" :clearable="false" />
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.ADDRESS") }} *</label>
              <v-text-field 
                v-model="data.hotelAddress" 
                :rules="[rules.required]"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.OTA_GROUP") }} *</label>
              <v-select 
                item-value="value"
                item-text="text"
                :items="select.otaGroup" 
                v-model="otaGroup" 
                :rules="[rules.required]"
                outlined
                dense
              >
                <template slot="no-data">
                  <div class="no-data">{{ $t('NO_DATA') }}</div>
                </template>
              </v-select>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.OTA") }} *</label>
              <v-select
                :items="select.ota"
                v-model="data.hotelOtas"
                :rules="[rules.required]"
                outlined
                dense
                multiple
                chips
                :item-disabled="checkIsItemDisabled"
                @change="$event => changeOta($event)"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0 || index === 1">
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 2" class="grey--text caption">
                    (+{{ data.hotelOtas.length - 2 }})
                  </span>
                </template>
                <template slot="no-data">
                  <div class="no-data">{{ $t('NO_DATA') }}</div>
                </template>
              </v-select>
            </v-col>
            <v-col sm="4">
              <vue-recaptcha
                ref="recaptcha"
                size="visible"
                sitekey="6LfwRFMbAAAAAOY3P12B2Bsl5RnS_WkDe7Q2ccSy"
                @verify="verify"
                @expired="onCaptchaExpired"
              />
            </v-col>
          </v-row>
        </div>
        </v-form>
        <!-- end hotel details -->

        <!-- create account -->
         <v-form ref="form3" lazy-validation v-on:submit.prevent class="w-100">
        <div :class=" (state == 3 ) ? 'create-account d-block' : 'create-account d-none'">
          <v-row>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.USERNAME") }} *</label>
              <v-text-field
                
                maxlength="50"
                :placeholder="$t('_REGISTER.CREATE_NEW_ACCOUNT_NAME')"
                v-model="data.username"
                outlined
                dense
                :error-messages="errors.username"
              >
              </v-text-field>
              <small v-if="isAccountTaken" class="invalid-text">{{ $t("ACCOUNT_IS_TAKEN") }}</small>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.CREATE_PASSWORD") }} *</label>
              <v-text-field
                :type="marker ? 'password' : 'text'"
                :placeholder="$t('_REGISTER.PASSWORD')"
                :isRealtimeValidate="true"
                v-model="data.password"
                outlined
                dense
                :append-icon="marker ? 'icon-eye-disabled' : 'icon-eye'"
                @click:append="toggleMarker"
                :rules="[rules.required]"
              >
               <template slot="no-data">
                  <div class="no-data">{{ $t('NO_DATA') }}</div>
                </template>
              </v-text-field>
            </v-col>
            <v-col sm="4">
              <label>{{ $t("_REGISTER.RETYPE_PASSWORD") }} *</label>
              <v-text-field
                type="password"
                :placeholder="$t('_REGISTER.RETYPE_PASSWORD')"
                :isRealtimeValidate="true"
                v-model="retypepassword"
                outlined
                dense
                :rules="[rules.required, rules.confirmPass]"
              >
               <template slot="no-data">
                  <div class="no-data">{{ $t('NO_DATA') }}</div>
                </template>
              </v-text-field>
              <!-- <div v-if="retypepassword && data.password !== retypepassword" class="text-danger fs-10">{{ $t('_ACCOUNT_SETTING.MESSAGE_PASSWORD_NOT_MATCHED') }}</div> -->
            </v-col>
          </v-row>
          <div class="terms-of-use">
            <p>{{ $t("_REGISTER.VALID_USERNAME_MESSAGE") }}</p>
            <p>
              {{ $t("_REGISTER.BY_CLICKING_REGISTER") }}
              <a
                href="#"
              >{{ $t("_REGISTER.TERM_AND_CONDITIONS") }}</a> &
              <a href="#">{{ $t("_REGISTER.PRIVACY_POLICY") }}</a>
            </p>
          </div>
        </div>
        </v-form>
        <!-- end create account -->

        <!-- final -->
         <v-form ref="form4" lazy-validation v-on:submit.prevent>
        <div id="final-register" :class=" (state == 4 ) ? 'd-block' : 'd-none'">
          <div class="img-mask">
            <img src="@/assets/like.svg" width="77px" height="73px" />
          </div>
          <div class="text-content">
            <p>{{ $t("_REGISTER.THANKS_FOR_REGISTER") }}</p>
            <p>{{ $t("_REGISTER.WAIT_APPROVE") }}</p>
          </div>
        </div>
        </v-form>
        <v-container class="bottom">
          <v-row class="p-0">
            <v-col sm="3" class="p-0">
              <span v-if="state != 4">* {{ $t("_REGISTER.REQUIRED_FIELD") }}</span>
            </v-col>
            <v-col sm="3" style="text-align:center"></v-col>
            <v-col sm="6" style="text-align: right" class="px-0">
              <v-btn v-if="state != 1 && state != 4"  depressed class="mr-2" @click="prevStep">
                <font-awesome-icon icon="arrow-left" class="mr-2" />
                {{
                $t("_REGISTER.BACK")
                }}
              </v-btn>
              <v-btn
                v-if="state != 4"
                :disabled="!formIsValid"
                @click="nextStep"
                color="primary"
              >
                {{ $t("_REGISTER.NEXT") }}
                <font-awesome-icon class="ml-2" icon="arrow-right" />
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </v-app>
</template>

<script>
import { systemService } from "@/_services/system-data.service.js";
import VueRecaptcha from "vue-recaptcha";
import { _alert } from "@/_helpers/function.js";
import { registerService } from "@/_services/register.service.js";
import { optionUTC } from "@/_helpers/globalData.js";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    VueRecaptcha,
    Treeselect,
  },
  data() {
    return {
        optionUTC: optionUTC(),
      lang: this.$i18n.locale,
      locations: [],
      country: null,
      city: null,
      otaGroup: null,
      otaAll: null,
        otaId: null,
      select: {
        hotelTypes: [],
        stars: [],
        countries: [],
        cities: [],
        districts: [],
        otaGroup: [],
        ota: []
      },
      data: {
        fullName: null,
        gender: 1,
        phone: null,
        email: null,
        position: null,
        hotelName: null,
        hotelWebsite: null,
        hotelPhone: null,
        hotelEmail: null,
        hotelTypeId: null,
        hotelStar: 0,
        hotelNumberOfRooms: null,
        hotelTaxCode: null,
        hotelLocId: null,
        hotelAddress: null,
        hotelOtaGroup: null,
        hotelOtas: [],
        username: null,
        password: null,
        // timeZoneStr: null
      },
      state: 1,
      isHuman: null,
      errors: {},
      isAccountTaken: false,
      isHotelEmailTaken: false,
      retypepassword: null,
      marker: true,
    };
  },
  computed: {
    rules() {
      return  {
        required: value => !!value && value.length > 0 || this.$t("_REGISTER.REQUIRED_FIELD"),
        counter: value => value.length <= 20 || 'Max 20 characters',
        phone: value => {
          const pattern = /^\+?\d{1,3}?[- .]?\(?(?:\d{2,3})\)?[- .]?\d\d\d[- .]?\d\d\d\d$/
          return pattern.test(value) || this.$t("PHONE_INVALID")
        },
        maxroom: value => value < 1000 || this.$t("MAXROOM_1000"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t("EMAIL_INVALID")
        },
        confirmPass:  value => value === this.data.password || this.$t("_ACCOUNT_SETTING.MESSAGE_PASSWORD_NOT_MATCHED"),
      }
    },
    formIsValid () {
      if ( this.state == 1 ) {
        return (
          this.data.fullName &&
          this.data.phone &&
          this.data.email &&
          this.data.position
        )
      }
      if ( this.state == 2 ) {
        return (
          this.data.hotelName &&
          this.data.hotelPhone &&
          this.data.hotelEmail &&
          this.data.hotelTypeId &&
          this.data.hotelNumberOfRooms &&
          this.data.hotelTaxCode &&
          this.data.hotelLocId &&
          this.data.hotelAddress &&
          this.data.hotelOtaGroup &&
          this.data.hotelOtas &&
          this.data.hotelOtas.length > 0 &&
          this.isHuman 
          // && this.data.timeZoneStr
        )
      }
      if ( this.state == 3 ) {
        return (
          this.data.username &&
          this.data.password
        )
      }
    },
  },
  watch: {
    country(value) {
      this.select.cities = this.locations
        .filter(x => x.parent == value)
        .map(x => {
          return {
            id: x.id,
            label: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
        if (this.select.cities.length > 0) {
          this.city = this.select.cities[0].id;
        }
    },
    city(value) {
      this.select.districts = this.locations
        .filter(x => x.parent == value && x.locType == 2 )
        .map(x => {
          return {
            id: x.id,
            label: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
        if (this.select.districts.length > 0) {
          this.data.hotelLocId = this.select.districts[0].id;
        }
    },
    otaGroup(value){
      this.data.hotelOtaGroup = value;
      this.data.hotelOtas = [];
      this.select.ota = this.otaAll
        .find(x => x.id == value).ota
        .map(y => {
          return {
            value: y.id,
            text: y.otaI18n.find(z => z.lang == this.defaultI18n).name,
            otaCode: y.otaCode
          };
        });
    },
    "data.email": {
      handler: function (newVar, oldVar) {
        this.userEmailTakenCheck();
      },
      deep: true
    },
    "data.hotelEmail": {
      handler: function (newVar, oldVar) {
        this.hotelEmailTakenCheck();
      },
      deep: true
    },
    "data.username": {
      handler: function (newVar, oldVar) {
        this.accountTakenCheck();
      },
      deep: true
    }
  },
  async created(){
      this.select.stars = [
        { id: 0, value: this.$t("NO_RANK") },
        { id: 1, value: this.$t("ONE_STAR") },
        { id: 2, value: this.$t("TWO_STAR") },
        { id: 3, value: this.$t("THREE_STAR") },
        { id: 4, value: this.$t("FOUR_STAR") },
        { id: 5, value: this.$t("FIVE_STAR") }
      ];

      await systemService.getHotelTypes().then(res => {
        this.select.hotelTypes = res.data.map(x => {
          return {
            value: x.typeId,
            text: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.select.hotelTypes = this.select.hotelTypes.filter(x => x.value);
      });

      await systemService.getLocations().then(res => {
        this.locations = res.data;
        this.select.countries = res.data
          .filter(x => !x.parent)
          .map(x => {
            return {
              id: x.id,
              label: x.i18ns.find(x => x.lang == this.defaultI18n).name
            };
          });
          this.country = this.select.countries[0].id;
      });

      await systemService.getAllOta().then(res => {
        this.otaAll = res.data;
        this.select.otaGroup = res.data.map(x => {
          return {
            value: x.id,
            text: x.titleVi
          };
        });
        this.select.otaGroup = this.select.otaGroup.filter(x => x.value);
      });  
  },
  methods: {
    toggleMarker () {
        this.marker = !this.marker
      },
    checkIsItemDisabled(item) {
      if (this.select.ota.find(e => e.otaCode === 'EZ_BE') && item.otaCode === 'EZ_GOOGLE_HOTEL' && !this.data.hotelOtas.includes(this.select.ota.find(e => e.otaCode === 'EZ_BE').value)) {
        return true;
      } else {
         return false;
      }
    },
    changeOta(value) {
        if (this.select.ota.find(e => e.otaCode === 'EZ_BE')
            && this.select.ota.find(e => e.otaCode === 'EZ_GOOGLE_HOTEL')
            && !value.includes(this.select.ota.find(e => e.otaCode === 'EZ_BE').value)
            && value.includes(this.select.ota.find(e => e.otaCode === 'EZ_GOOGLE_HOTEL').value)
        ) {
            const new_arr = value.filter(item => item !== this.select.ota.find(e => e.otaCode === 'EZ_GOOGLE_HOTEL').value);
            this.data.hotelOtas = [...new_arr];
        }
    },
    nextStep() {
      let form_validate = this.$refs[`form${this.state}`].validate();
      if (form_validate) {
        if (this.state !== 3 || (this.state === 3 && this.retypepassword && this.retypepassword === this.data.password)) {
          this.state += 1;
        }
        switch (this.state) {
          case 4:
            this.registerAccount();
            break;
        }
      }
    },
    prevStep() {
      this.state -= 1;
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    verify(res) {
      if (res) {
        this.isHuman = true;
      } else {
        this.isHuman = false;
      }
    },
    registerAccount() {
      registerService.register(this.data).then(res => {
        if (res.responseCode == 0) {
          _alert(res, this.$t("REGISTER_SUCCESS"), false);
        }
        if (res.responseCode != 0) {
          _alert(res, this.$t("USER_NAME_OR_EMAIL_IS_EXISTED"), false);
          if (res.data == "USER_IS_EXIST") {
            this.errors.username.error = true;
            this.errors.username.message = this.$t("ACCOUNT_IS_TAKEN");
          }
          return false;
        }
        let username = res.data.username;
        let token = res.data.token;
        localStorage.setItem(
          "justRegistedUser",
          JSON.stringify({ username: username, token: token })
        );
      });
    },
    userEmailTakenCheck() {
      registerService.registerDupplication({email: this.data.email}).then(res => {
        if (res.responseCode != 0) {
          this.errors.email = this.$t("EMAIL_USER_IS_EXIST");
        } else {
          this.errors.email = "";
        }
        this.$forceUpdate();
      });
    },
    hotelEmailTakenCheck() {
      registerService.registerDupplication({hotelEmail: this.data.hotelEmail}).then(res => {
        if (res.responseCode != 0) {
          this.errors.hotelEmail = this.$t("EMAIL_HOTEL_IS_EXIST");
        } else {
          this.errors.hotelEmail = "";
        }
        this.$forceUpdate();
      });
    },
    accountTakenCheck() {
      registerService.registerDupplication({username: this.data.username}).then(res => {
        if (res.responseCode != 0) {
          this.errors.username = this.$t("ACCOUNT_IS_TAKEN");
        } else {
          this.errors.username = "";
        }
        this.$forceUpdate();
      });
    },
    redirectToLogin() {
      location.href = "login";
    }
  }
};
</script>
